import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import React from 'react'
import styled from 'styled-components'
import {useEditMode, useSetEditMode} from 'Event/EditModeProvider'
import PreviewConfigButton from 'Event/Dashboard/editor/views/ConfigBar/PreviewConfigButton'
import PreviewConfig from 'Event/Dashboard/editor/views/ConfigBar/PreviewConfig'
import {useToggleArray} from 'lib/toggle'

export default function PreviewRulesToolbarItems() {
  const isEditMode = useEditMode()

  const setIsEditMode = useSetEditMode()
  const [showingPreviewConfig, togglePreviewConfig] = useToggleArray()

  const toggle = () => setIsEditMode(!isEditMode)

  return (
    <RightItems>
      <FormControlLabel
        control={
          <Switch
            checked={!isEditMode}
            onChange={toggle}
            color="primary"
            aria-label="toggle preview mode"
          />
        }
        label="Preview"
      />
      <PreviewConfigButton onClick={togglePreviewConfig} />
      <PreviewConfig
        showing={showingPreviewConfig}
        onClose={togglePreviewConfig}
      />
    </RightItems>
  )
}

const RightItems = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
